<template>
<master-layout pageTitle="Message Templates">
	<div>
		<div>
			<div v-if="whatsappConnected">
				<div class="toolbar-header">
					<VIcon @click="() => $router.go(-1)" :size="-4" name="arrow-left-line" class="cursorPointer" />
					<h2 class="vtext-card-title--light">{{ $route.params.id ? 'Edit' : 'Create' }} message template</h2>
					<VButton class="vvd-btn-primary save-btn" connotation="cta" appearance="filled" label="Save Template" :disabled="spinnerLoading || isViewOnlyMode" @click="saveTemplate"></VButton>
				</div>
				<!-- Mobile tab switcher -->
				<div class="mobile-tabs">
					<button :class="['tab-item', { active: activeTab === 'message' }]" @click="activeTab = 'message'">Message Template</button>
					<button :class="['tab-item', { active: activeTab === 'preview' }]" @click="activeTab = 'preview'">Preview</button>
				</div>
				<div v-if="$route.params.id" class="info-box justifyBetween marginBottom gridMargin">
					<div class="flexContainer"> 
						<VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" />
						<p class="info-text">A template can be edited only when its status is <strong>Approved</strong>, <strong>Rejected</strong>, or <strong>Paused</strong>. Edits are limited to <strong>once</strong> per day, and up to <strong>10</strong> times per month. </p>
					</div>
					<div class="text-right">
						<VButton class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Learn More" @click="learnMore"></VButton>
					</div>
				</div>
				<div class="gridMargin">
          <div class="vrow" style="margin: 0px">
            <div class="vcol vcol--no-padding vcol-xl-8 vcol-lg-8 vcol-md-8 vcol-sm-12 vcol-xs-12 custPaddingRight"> 
              <div v-if="activeTab === 'message'">
								<div class="model-sections marginBottom">
									<div class="templateHeader">
										<div class="flexContainer">
											<span class="messageHeader">{{ $route.params.id ? 'Edit' : 'Create' }} message template</span>
										</div>
										<div>
											<span class="vtext-body"> <span class="status" :class="statusClass(dummyTemplate.status)"></span> {{ getStatusLabel(dummyTemplate.status) }} </span>
										</div>
									</div>
									<div class="sectionPadding"> 
										<div>
											<div class="flex-start paddingBottom flexText">
												<p class="sub-title ion-no-margin">Name</p>
												<HelpTooltip>
													<ul>
														<li>Max 256 characters</li>
														<li>Space and tabs is not supported </li>
														<li>Only lowercase alphanumeric characters with underscores</li>
														<li>Must start with a lowercase letter</li>
													</ul>
												</HelpTooltip>
											</div>
											<div class="counter-wrapper">
												<VTextField v-model="dummyTemplate.template_name" :maxlength="256" placeholder="Enter Name" :readonly="thisTemplate !== undefined" appearance="ghost" class="vivid-input"></VTextField>
												<div class="custom-counter">
														{{ (dummyTemplate.template_name || '').length }}/256
													</div>
											</div>
										</div>
										<div class="optionsContainer domainContainer">
											<div>
												<p class="sub-title">Language</p>
												<selectDropDown
													:options="localeFullFormData_whatsapp_to_show"
													:isDisabled="false"
													popoverSize="cover"
													placeholder="language"
													:clientSideSearch="true"
													@onSelectOption="val => {
														dummyTemplate.language = val.selectedOption.id;
													}"
													:selectedValueProp="dummyTemplate.language"
												/>
											</div>
											<div>
												<div class="flex-box">
													<p class="sub-title">Template type</p>
													<a href="https://developers.facebook.com/docs/whatsapp/updates-to-pricing/new-template-guidelines/" target="_blank" rel="noreferer noopener" class="custMarginTop">
														<VIcon :name="helpCircleOutline" connotation="cta" style="padding-bottom: 4px; font-size: 14px" />
													</a>
												</div>
												<selectDropDown
													:options="availableCategories.map(c => ({ title: c.name, value: c.value }))"
													:selectedValueProp="dummyTemplate.category"
													:isDisabled="thisTemplate !== undefined"
													placeholder="Select Category"
													@onSelectOption="val => dummyTemplate.category = val.selectedValue"
												/>
											</div>
											<div v-if="dummyTemplate.category == 'MARKETING' || dummyTemplate.category == 'AUTHENTICATION'" class="optionBox">
												<div class="flex-box">
													<p class="sub-title">{{ dummyTemplate.category === 'MARKETING' ? 'Message type' : (dummyTemplate.category === 'AUTHENTICATION' ? 'Template type' : '') }}</p>
												</div>
												<selectDropDown
													:options="templateOptions.map(c => ({ title: c.name, value: c.value }))"
													:selectedValueProp="dummyTemplate.template_subtype"
													:isDisabled="!!$route.params.id"
													placeholder="Select template"
													@onSelectOption="val => { dummyTemplate.template_subtype = val.selectedValue; onTemplateSelection(); }"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="model-sections">
									<div class="sectionPadding">
										<div>
											<!-- default template start -->
											<div v-if="dummyTemplate.template_subtype == 'generic' || dummyTemplate.template_subtype == 'Coupon'">
												<templateOffersHeaders :headerData="body.header" :template_subtype="dummyTemplate.template_subtype" @headerText="updatedValues" @uploadedFiles="uploadedFileData" @selectedBodyFormat="selectedBodyFormat" :isViewOnlyMode="isViewOnlyMode" />
											</div>
											<!-- default template end -->

											<!-- LTO template start -->
											<div v-else-if="dummyTemplate.template_subtype == 'LTO'">
												<templateOffersHeaders :headerData="body.header" :template_subtype="dummyTemplate.template_subtype" @headerText="updatedValues" @uploadedFiles="uploadedFileData" @selectedBodyFormat="selectedBodyFormat" :isViewOnlyMode="isViewOnlyMode" />
												<div class="domainContainer">
													<p class="title paddingBottom ion-no-margin">Offer Title</p>
													<p class="sub-title paddingBottom ion-no-margin">Enter a title for the LTO (Max 16 characters).</p>
													<div class="counter-wrapper">
														<VTextField v-model="lto_offerTitleText" :maxlength="16" placeholder="Enter offer title" aria-label="Enter offer title" appearance="ghost" class="vivid-input"></VTextField>
														<div class="custom-counter">
																{{ (lto_offerTitleText || '').length }}/16
														</div>
													</div>
												</div>

												
												<div class="expiryButton">
													<VSwitch :checked="lto_offerExpirationRadio" @change="(e) => lto_offerExpirationRadio = e.target.checked" connotation="cta" label="Does this offer expire?" :disabled="isViewOnlyMode"></VSwitch>
												</div> 

												<div v-if="lto_offerExpirationRadio" class="domainContainer">
													<p class="sub-title">Expiration Date &amp; Time</p>
													<DateTime id="expiration-date-time" v-model="expiration_date_time" :format="'YYYY-MM-DD HH:mm:ss'" :minValidation="minValidationObject" :maxValidation="{ enabled: true, value: 13, type: 'months' }"></DateTime>
												</div>
											</div>
											<!-- LTO template end -->
											<!-- Carousel template start -->
											<div v-else-if="dummyTemplate.template_subtype == 'Carousel'">
												<templateOffersHeaders :template_subtype="dummyTemplate.template_subtype" :isViewOnlyMode="isViewOnlyMode" />
											</div>
											<!-- Carousel template end -->
											
											<div v-if="dummyTemplate.template_subtype !== undefined || dummyTemplate.category == 'AUTHENTICATION' || dummyTemplate.category == 'UTILITY'" class="paddingBottom">
												<div class="info-box marginBottom">
													<VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" />
													<p class="info-text ion-no-margin">Avoid using the entire character count limit when your message contains message variables.</p>
												</div> 
												<div class="BodyFlexContainer marginBottom">
													<div class="mobileMargin">
														<p class="title ion-no-margin paddingBottom">Body</p>
														<p class="sub-title ion-no-margin">Enter the text for your message in the language you’ve selected (Max {{ customMaxLength }} characters).</p>
													</div>
												</div>
												<div class="bodyContainer">
													<RichTextBoxV2
														ref="TextRichTextBox"
														:value="body.body.text"
														:showSmiley="!isViewOnlyMode"
														:showCustomFiledInsertion="true"
														:maxLength="customMaxLength"
														:readonly="isViewOnlyMode"
														:showBotVariable="false"
														@input="(prop) => body.body.text = prop"
														@addParams="modifyParams"
														@removeParams="removeParams"
														:placeholder="editorOption.placeholder || 'Type a message'"
														contentType="TEXT"
														style="width: 100%"
													/>
													<div v-if="dummyTemplate.template_subtype !== 'Carousel'">
														<VueDraggable v-model="singleButton" animation="150" handle=".reorder-container">
															<div v-for="(thisButton, bIndex) in singleButton" :key="bIndex" @click="parseButtonInfo(thisButton, bIndex)" class="bttnContainer cursorPointer" :class="{ 'activeButton' : bIndex == popperIndex, 'lastButton' : bIndex == 9 , 'ltoButton': dummyTemplate.template_subtype == 'LTO' &&  bIndex == 1, 'disabledContainer': isViewOnlyMode }" :style="{ justifyContent: thisButton.type === 'QUICK_REPLY' ? 'flex-start' : 'center', marginTop: '-3px' }">
																<div v-if="thisButton.type == 'QUICK_REPLY'" class="reorder-container button-text-container">
																	<VIcon v-if="getIcon(thisButton)" :name="getIcon(thisButton)" connotation="cta" class="reorder-icon" />
																</div>
																<div class="button-text-container" :class="{ 'buttonMargin': thisButton.type == 'QUICK_REPLY' }">
																	<VIcon v-if="(thisButton.action !== undefined || thisButton.type !== undefined) && getIcon(thisButton)" :name="getIcon(thisButton)" connotation="cta" />
																	<span class="bttnTitle">{{ thisButton.text }}</span>
																</div>
															</div>
														</VueDraggable>
														<button v-if="singleButton.length < 10 && dummyTemplate.template_subtype !== 'LTO'" @click="() => { singleButton.push({ text: 'Button', type: undefined, payload: undefined }) }" :disabled="isViewOnlyMode" class="templateAddButton">
															<VIcon name="plus-line" :size="-5" style="color: #B073FF; padding-right: 10px;" />
															Add New {{ '(' + (10 - singleButton.length) + ' left)' }} 
														</button>
													</div>
												</div>
											</div>
											<!-- Carousel template start -->
											<div v-if="dummyTemplate.template_subtype == 'Carousel'">
												<CarouselTemplate ref="CarouselComponent" :carouselData="carousel_message_json" @finalCarouselData="finalCarouselData" :isViewOnlyMode="isViewOnlyMode" :showBotVariable="false"/>
											</div>
											<!-- Carousel template end -->
											<div v-if="shouldShowPopper" class="popperContainer">
												<div v-if="selectButtonType && dummyTemplate.template_subtype !== 'LTO'" class="marginBottom flex-between"> 	<!-- Selecting Button type -->
													<div class="flex100P">
														<p class="sub-title paddingBottom ion-no-margin">Button Type</p>
														<selectDropDown
															:options="buttonTypeOptions"
															:selectedValueProp="buttonType"
															:isDisabled="isViewOnlyMode"
															placeholder="Select an option"
															@onSelectOption="val => { buttonType = val.selectedValue; onButtonTypeSelection(); }"
														/>
													</div>
													<VIcon v-if="openPopper == undefined" name="delete-line" connotation="alert" class="trashIcon cursorPointer" style="flex: 0; padding-top: 20px" @click="removeButton" />
												</div>
												<div v-if="openPopper === 'simple' || openPopper === 'detailed'">
													<popper :key="`popper-${buttonType}`" :type="openPopper" channel="whatsapp" :showEmoji="false" :showDynamicURL="true" :enableOptions="false" :is_agent_or_group_req="showAgents" :deleteButton="enableCloseButton" :config="popperConfig" @submit="popperSubmit" @deleteBttn="removeButton"/>
												</div>
											</div>
											<!-- Custom field text -->
											<div class="domainContainer" v-if="custom_field_body_params.length > 0">
												<p class="title">Add sample text for following custom fields</p>
												<div v-for="(custField, index) in custom_field_body_params" :key="index">
													<p class="sub-title">{{ custField.text.replace(/{|}/g, '') }}</p>
													<VTextField v-model="custField.value" placeholder="Enter sample text" aria-label="sample text" appearance="ghost" class="vivid-input" :readonly="isViewOnlyMode"></VTextField>
												</div>
											</div>
										</div>
								
										<div v-if="enableFooter" class="domainContainer brdr_top">
											<p class="title footerTop">Footer (optional)</p>
											<p class="sub-title">Add a short line or text to the button of your message template (Max 60 characters).</p>
											<div class="counter-wrapper">
												<VTextField v-model="body.footer.text" :maxlength="60" placeholder="Enter footer text" aria-label="footer text" :readonly="isViewOnlyMode" appearance="ghost" class="vivid-input"></VTextField>
												<div class="custom-counter">
														{{ (body.footer.text || '').length }}/60
												</div>
											</div>
										</div>
									</div>	
								</div>
							</div>
            </div>
            <!-- preview -->
            <div class="vcol vcol--no-padding vcol-xl-4 vcol-lg-4 vcol-md-4 vcol-sm-12 vcol-xs-12 model-sections">
              <div :class="activeTab === 'preview' ? 'prevMobile' : 'prevDesktop'">
                <div class="previewHeader">
                  <span class="messageHeader">Preview</span>
                </div>
                <div class="sectionPadding">
									<WhatsAppPreview :body="body" origin="templates" :selectedLanguage="dummyTemplate.language" :allButtons="singleButton" :templateType="dummyTemplate.template_subtype" :lto_offerTitleText="lto_offerTitleText" :carouselMessage="carousel_message_json" :expiration_date_time="expiration_date_time"></WhatsAppPreview>
                </div>
              </div>
            </div>
						<!-- Copilot template generator -->
						<!-- <ion-col v-else size-xl="4" size-lg="4" size-md="4" size-sm="12" size-xs="12" class="model-sections">
							<div class="previewHeader flexBox">
								<div>
									<p class="header paddingBottom ion-no-margin">Copilot</p>
									<p class="sub-title ion-no-margin">Fill out the fields below to help AI generate your template.</p>
								</div>
								<div>
									<ion-buttons slot="end">
										<ion-button @click="OpenAIMode = false">
											<VIcon :name="closeOutline"></VIcon>
										</ion-button>
									</ion-buttons>
								</div>
							</div>
							<div v-if="!chatGPT.generating" class="sectionPadding">
								<div v-if="chatGPT.generatedOnce">
									<div class="marginBottom">
										<CopilotPreview :chatGPTBody="chatGPT.generatedText"></CopilotPreview>
									</div>
									<div class="info-box marginBottom">
										<VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
										<p class="info-text ion-no-margin">You can still make edits to this template later.</p>
									</div>
									<ion-button @click="() => { body.body.text = chatGPT.generatedText?.length ? chatGPT.generatedText : undefined}" expand="block" fill="solid" class="bttnPrimary marginBottom ion-no-margin">
										Use this
									</ion-button>
									<ion-button @click="generateText" fill="outline" class="secondaryBttn marginBottom ion-no-margin" expand="block">
										Generate again
									</ion-button>
									<ion-button @click="() => chatGPT.generatedOnce = false" fill="outline" class="secondaryBttn ion-no-margin" expand="block">
										Generate new Template
									</ion-button>
								</div>
								<div v-else>
									<div class="chatgpt-container">
										<div>
											<p class="sub-title">Product name (optional)</p>
											<ion-input type="text" v-model="chatGPT.p_name" placeholder="Organic Lipstick - Plum (3.7g)" aria-label="product name" class="sctn-input ion-no-border"></ion-input>
										</div>
										<div>
											<p class="sub-title">Occasion <span class="trashIcon">*</span></p>
											<ion-input type="text" v-model="chatGPT.occasion" placeholder="Christmas Sale" aria-label="occassion" class="sctn-input ion-no-border"></ion-input>
										</div>
										<div>
											<p class="sub-title">Discount / promo (optional)</p>
											<ion-input type="text" v-model="chatGPT.discount" placeholder="Use code flat50 to get upto 50% off" aria-label="Discount" class="sctn-input ion-no-border"></ion-input>
										</div>
										<div>
											<p class="sub-title">Target audience (optional)</p>
											<ion-input type="text" v-model="chatGPT.target" placeholder="Women of age 20-30 years" aria-label="target audience" class="sctn-input ion-no-border"></ion-input>
										</div>
										<div>
											<p class="sub-title">Tone<span class="trashIcon">*</span></p>
											<ion-select v-if="chatGPT.tone !== 'custom'" :toggle-icon="chevronDownOutline" fill="outline" aria-label="tone" v-model="chatGPT.tone" interface="popover" placeholder="Select" class="ion-no-border slctContainer">
												<ion-select-option disabled :value="''">Select Tone</ion-select-option>
												<ion-select-option v-for="(thisTone, tIndex) in availableTones" :key="tIndex" :value="thisTone">{{ thisTone }}</ion-select-option>
											</ion-select>
										</div>
										<div class="marginBottom">
											<p class="sub-title">Key phrases (comma separated)<span class="trashIcon">*</span></p>
											<ion-input type="text" v-model="chatGPT.key_phrases" placeholder="Enter phrases separated by comma" aria-label="key phrases" class="sctn-input ion-no-border"></ion-input>
										</div>
									</div>
									<ion-button @click="generateText" fill="solid" class="bttnPrimary" expand="block">
										<VIcon :name="shuffle" style="margin-right: 5px;"></VIcon>
										Generate
									</ion-button>
								</div>
							</div>
							<div v-else>
								<div class="text-center generatingContainer">
									<img src="../../../resources/images/generateAI.svg" alt="empty cart" />
									<p class="generateText">Generating text...</p>
								</div>
							</div>
            </ion-col> -->
          </div>
        </div>
			</div>
			<div v-else>
				<page-access-not-allowed></page-access-not-allowed>
			</div>
		</div>
	</div>
</master-layout>
</template>

<script>
import '@/resources/css/sales-channel.css';
import { localeFullFormData_whatsapp } from '../../../resources/js/all-locale-data';
import { VueDraggable } from 'vue-draggable-plus';
import marketingOptinSubscribed from '@/resources/images/marketing-optin-subscribed-button.svg';
import marketingOptinUnsubscribed from '@/resources/images/marketing-optin-unsubscribed-button.svg';
import myInput from '@/components/myInput';
import popper from '@/components/popper';
import templateOffersHeaders from '@/components/whatsapp-templates/offer-template-headers';
import WhatsAppPreview from "@/pages/broadcast/whats-app-preview";
import DateTime from "@/components/DateTime.vue";
import CarouselTemplate from "@/components/whatsapp-templates/carousel-component";
import apiInterceptor from '@/shared/apiInterceptor';
import { whatsappTemplatesQueryOptions } from '@/composables/useWhatsappTemplates';
import { queryClient } from '@/shared/queryClient';
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { environment } from '@/shared/env';
import messageTags from '@/resources/data/message-tags.json';
import { statusClass, getStatusLabel } from '@/helpers/status.helpers';
import HelpTooltip from "@/components/HelpTooltip.vue";
import selectDropDown from '@/components/selectDropDown.vue';

function jsonSizeInKB(jsonObject) {
  const jsonString = JSON.stringify(jsonObject);
  const bytes = new TextEncoder().encode(jsonString).length;
  const kb = bytes / 1024;
  return kb;
}

export default {
	components: {
		VueDraggable,
		HelpTooltip,
		myInput,
		popper,
		templateOffersHeaders,
		WhatsAppPreview,
		DateTime,
		CarouselTemplate,
		RichTextBoxV2,
		selectDropDown
	},
  setup() {
    const { whatsappConnected, whatsAppSocialData } = useSocialChannels();
    return { whatsappConnected, whatsAppSocialData };
  },
  data() {
    return {
			localeFullFormData_whatsapp,
			closeOutline: 'close-line',
			informationCircleOutline: 'info-line',
			shuffle: 'refresh-line',
			helpCircleOutline: 'help-line',
			addOutline: 'plus-line',
			reorderFourOutline: 'reorder-vertical-line',
			callOutline: 'call-line',
			shareOutline: 'share-line',
			copyOutline: 'copy-2-line',
			arrowUndoOutline: 'undo-solid',
			chevronDownOutline: 'chevron-down-line',
			openPopper: undefined,
			activeTab: 'message',
			popperIndex: -1,
			thisTemplate: undefined,
			spinnerLoading: false,
			availableCategories: [
        {
					name: "Marketing",
					value: "MARKETING"
        },
        /* {
					name: "Authentication",
					value: "AUTHENTICATION"
        }, */
        {
					name: "Utility",
					value: "UTILITY"
        }
			],
			availableMarketingTemplateSubTypes: [
				{ name: 'Generic / Custom', value: 'generic' },
				{ name: 'Carousel', value: 'Carousel' },
				{ name: 'Coupon Code', value: 'Coupon' },
				{ name: 'Limited-Time Offer', value: 'LTO' },
				// { name: 'Catalog', value: 'Catalog' },
				// { name: 'Multi-Product Message', value: 'MPM' },
			],
			availableAuthenticationCategories: [
				{ name: 'Copy Code', value: 'copy_code' },
				{ name: 'One-Tap Autofill', value: 'one_tap' },
				{ name: 'Zero-Tap', value: 'zero_tap' },
			],
			dummyTemplate: {
				category: 'MARKETING',
				id: undefined,
				language: 'en',
				status: undefined,
				template_id: undefined,
				template_name: undefined,
				template_subtype: 'generic',
			},
			body: {
				header: {
					format: undefined,
					text: undefined,
					example: ''
				},
				body: {
					text: undefined,
					params: [],
					example: []
				},
				footer: {
					text: undefined,
				},
			},
			singleButton: [],
			exampleParamOptions: [
				{ text: "{User's First Name}", param: "<userfirstname>", example: "John" },
				{ text: "{User's Last Name}", param: "<userlastname>", example: "Snow" },
				{ text: "{User's Email}", param: "<useremail>", example: "support@mybrandstore.com" },
				{ text: "{User's Phone}", param: "<userphone>", example: "+6590000000" },
				{ text: '{Custom Field}', param: "<custom_field_", example: "custom_field_1" }
			],
			popperConfig: {
				text: undefined,
				action: undefined,
				payload: undefined
			},
			availableTones: [
				'Formal',
				'Casual',
				'Fun'
			],
			allTemplates: [],
			custom_field_body_params: [],
			allExampleValues: [],
			custom_field_values: [],
			lto_offerTitleText: '',
      lto_offerExpirationRadio: true,
			expiration_date_time: null,
			selectButtonType: false,
			buttonType: '',
			carousel_message_json: {
				BODY: {
						text: ""
				},
				CAROUSEL: {
						cards: []
				}
			},
			minValidationObject: {
        enabled: true,
        value: 1,
        type: 'day'
      },
			editorOption: {
        placeholder: 'Type a message',
      },
			simpleMessageTags: [],
			showAgents: false,
			singleButtonbeforeModification: []
    }
	},
	computed: {
		buttonTypeOptions() {
			const options = [
				{ title: 'Phone number (Maximum 1)', value: 'phone', disabled: this.disablePhoneButtonType },
				{ title: this.dummyTemplate.template_subtype == 'Coupon' ? 'URL (Maximum 1)' : 'URL (Maximum 2)', value: 'url', disabled: this.disableURLButtonType },
				{ title: 'Quick Reply (Maximum 10)', value: 'quickReply' }
			];
			// Keep disabled options in the list so the currently selected value
			// (e.g. phone/url) still renders as selected; disabled prevents
			// re-selecting a limit-reached type [APICC-3445].
			return options;
		},
		localeFullFormData_whatsapp_to_show () {
			return this.localeFullFormData_whatsapp.map(elm => {
				return { ...elm, ...{ title: elm.name } }
			}
			)
		},
		enableCloseButton(){
			return this.dummyTemplate.template_subtype !== 'LTO' ;
		},
		disableURLButtonType() {
				let URLButtons = this.singleButton.filter(button => { return ['website', 'URL'].includes(button.action); }).length;

				if (this.dummyTemplate.template_subtype === 'generic') {
						return URLButtons >= 2; // Disable if 2 URLs already exist
				} else if (this.dummyTemplate.template_subtype === 'Coupon') {
						return URLButtons >= 1; // Disable if 1 URL already exists
				}
				return false;
		},
		disablePhoneButtonType() {
			let phoneNumberButton = this.singleButton.filter(button => { return ['phone', 'PHONE_NUMBER', 'phone_number'].includes(button.action); }).length;

				if (this.dummyTemplate.template_subtype === 'generic') {
						return phoneNumberButton >= 1; // Disable if 1 phone number already exists
				} else if (this.dummyTemplate.template_subtype === 'Coupon') {
						return phoneNumberButton >= 1; // Disable if 1 phone number already exists
				}
				return false;
		},
		templateOptions() {
			if (this.dummyTemplate.category === 'MARKETING') {
					return this.availableMarketingTemplateSubTypes;
			} else if (this.dummyTemplate.category === 'AUTHENTICATION') {
					return this.availableAuthenticationCategories;
			} else {
					return [];
			}
    },
		isViewOnlyMode() {
			// Editable if there's no ID (i.e., we're creating a new template)
			if (!this.$route.params.id) {
				return false;
			}

			const allowedCategories = ['MARKETING', 'AUTHENTICATION', 'UTILITY'];
			const viewOnlyStatuses = ['pending', 'limit_exceeded'];

			const category = this.dummyTemplate?.category;
			const status = this.dummyTemplate?.status?.toLowerCase();

			// View-only only if category & status match
			return allowedCategories.includes(category) && viewOnlyStatuses.includes(status);
		},
		enableFooter(){
			return this.dummyTemplate.category != 'AUTHENTICATION' && this.dummyTemplate.template_subtype != 'Carousel' &&  this.dummyTemplate.template_subtype != 'LTO'
		},
		shouldShowPopper(){
			return this.selectButtonType || this.openPopper === 'simple' || this.openPopper === 'detailed'
		},
		customMaxLength() {
			if(this.dummyTemplate.template_subtype === 'LTO'){
				return 600
			} else return 1024
		}
	},
	async ionViewWillEnter() {
		this.resetTemplateData('all');
		this.$route.params.id ? this.init() : this.fetchTemplates();
		this.setMessageTags();
	},
  methods: {
		statusClass,
		getStatusLabel,
		async init() {
			if (!this.whatsAppSocialData) {
				useUIStore().updateToast({ open: true, message: "No WhatsApp account connected.", type: "danger" });
				return;
			}
			try {
				useUIStore().updateLoading({ isLoading: true, message: 'Loading template...' });
				let templateId = this.$route.params.id;
				let getTemplateResponse = await apiInterceptor.get(environment("VUE_APP_API_URL") + "social/v1/whatsapp/" + this.whatsAppSocialData.id + '/template/' + templateId );
				this.thisTemplate = getTemplateResponse.data;
					this.dummyTemplate.category = this.thisTemplate.category;
					this.dummyTemplate.language = this.thisTemplate.language;
					this.dummyTemplate.status = this.thisTemplate.status.toLowerCase();
					this.dummyTemplate.template_name = this.thisTemplate.template_name;
					this.dummyTemplate.template_subtype = this.thisTemplate.template_subtype;
					this.body.body.text = this.thisTemplate.message.BODY.text;
					
					const bodyExamples = this.thisTemplate.message.BODY?.example ?? [];
					for (const example of bodyExamples) {
						if (typeof example === 'string') {
							this.allExampleValues.push(example);
						} else if (Array.isArray(example)) {
							this.allExampleValues.push(...example); 
						}
					}
					if(this.thisTemplate.message.BUTTONS && this.thisTemplate.message.BUTTONS.length) {
						this.singleButton = [];
						this.singleButtonbeforeModification = [];
						this.thisTemplate.message.BUTTONS.forEach((thisButton) => {
							const keyName = thisButton.type == 'QUICK_REPLY' ? 'type' : 'action';
							const newButton = {
									text: thisButton.text,
									[keyName]: thisButton.type == 'URL' ? 'website' : thisButton.type == 'PHONE_NUMBER' ? 'phone' : thisButton.type,
									payload: thisButton.type == 'URL' ? thisButton.url : thisButton.type == 'PHONE_NUMBER' ? thisButton.phone_number : thisButton.payload
							};
							// For dynamic URL
							if (thisButton.type === 'URL' && thisButton.example !== undefined) {
								newButton.url_type = 'dynamic';
								newButton.example = thisButton.example;
							}
							this.singleButton.push(newButton);
						})
					}
					const headerMessage = this.thisTemplate.message.HEADER;
					const footerMessage = this.thisTemplate.message.FOOTER;

					this.body.header.format = headerMessage?.format;
					if (this.body.header.format === 'TEXT') {
						this.body.header.text = headerMessage?.text;
					}
					this.body.header.example = headerMessage?.example;
					this.body.footer.text = footerMessage?.text;

					const messageParamsValue = this.thisTemplate.message_params.BODY ?? [];


					for (var i=0; i < messageParamsValue.length; i++) {
						for(var key in messageParamsValue[i]){
							if (key.indexOf('<custom_field_') > -1) {
								const value = this.allExampleValues[i] || '';

								this.custom_field_values.push({
									"key": key,
									"value": value
								});
							}
						}
					}
					if (messageParamsValue && messageParamsValue.length) {
						messageParamsValue.forEach((thisParam, paramIndex) => {
							const param = Object.keys(thisParam)[0];
							const pIndex = paramIndex + 1;							
							this.addParam(param, true, pIndex);
						});
						// Convert all {{...}} to <...>
						this.body.body.text = this.body.body.text.replace(/{{([^}]+)}}/g, (_, match) => {
							// Only normalize if it's not a custom field
							let normalized = match
								.toLowerCase()
								.replace(/['"\s]+/g, '') // remove spaces and apostrophes
								.replace(/[^a-z0-9_]/gi, ''); // remove any non-alphanumeric characters
							
							// Remove "users" from the beginning if present
							if (normalized.startsWith('users')) {
								normalized = normalized.replace(/^users/, 'user');
							}

							return `<${normalized}>`;
						});	
						this.body.body.text = this.body.body.text.replace(/{(custom_field_[^}]+)}/g, '<$1>');
					}

					const customFieldParams = this.body.body.params.filter(item => item.text.includes("{custom_field_"));		
					this.custom_field_body_params = customFieldParams.map((item, index) => {
						const newItem = { ...item };
						newItem.key = this.custom_field_values[index].key;
						newItem.value = this.custom_field_values[index].value || 'Custom field'; // Add the value from allExampleValues array
						return newItem;
					});
					if (this.thisTemplate.template_subtype === 'LTO') {
						const ltoMessage = this.thisTemplate.message.limited_time_offer;
						const ltoParams = this.thisTemplate.message_params.limited_time_offer;

						if (ltoMessage !== undefined) {
							this.lto_offerExpirationRadio = ltoMessage.has_expiration;
							this.lto_offerTitleText = ltoMessage.text;
						}

						if (ltoParams !== undefined && ltoParams.expiration_time !== undefined) {
								this.expiration_date_time = ltoParams.expiration_time;
						}
					} 
					else if(this.thisTemplate.template_subtype == 'Carousel'){
						var msgData_carousel = this.thisTemplate.message;

						msgData_carousel.CAROUSEL.cards.forEach(card => {
						if (card.components && card.components[2]) {
							card.components[2].buttons.forEach(button => {
								if (button.title) {
									button.text = button.title;
									delete button.title;
								}
								if (button.type === 'URL') {
									button.payload = button.url;
									delete button.url;									
									button.type = "website";
									// For dynamic URL
									if (button.example !== undefined) {
										button.url_type = 'dynamic';
									}
								}
							});
							}
							if (card.components && card.components[0]) {
								card.components[0].filesUploading = false;
							}
						});
						this.carousel_message_json = msgData_carousel;
					}
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger",
				  duration: 4000
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
		},
		async fetchTemplates() {
      if (!this.whatsAppSocialData) {
        useUIStore().updateToast({ open: true, message: "No WhatsApp account connected.", type: "danger" });
        return;
      }
      try {
        this.loading = true;
				this.singleButton = [];
        const response = await queryClient.fetchQuery(whatsappTemplatesQueryOptions(this.whatsAppSocialData.id, { size: '-1' }));
        this.allTemplates = response.templates;
				this.dummyTemplate.template_name = this.getNewTemplateName();
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" })
      } finally {
        this.loading = false;
      }
    },
		uploadedFileData(urlData) { // Uploaded File Data
			this.body.header.example = urlData[0];
		},
		popperSubmit(result) {
			const data = result.new;
			const button = this.singleButton[this.popperIndex];
			
			if (this.popperIndex > -1 && button) {
				// Set common properties for all buttons
				Object.assign(button, {
					text: data.text,
					payload: data.payload,
					postback_action_type: data.postback_action_type,
					postback_action: data.postback_action,
					action: data.action
				});
				
				// Handle action-specific properties
				switch(data.action) {
					case 'website':
						if (data.url_type) {
							button.url_type = data.url_type;
						}
						break;
					case 'phone':
					case 'phone_number':
						button.type = 'PHONE_NUMBER';
						button.phone_number = data.payload;
						break;
					case 'COPY_CODE':
						button.payload = '12345';
						button.postback_action_type = 'COPY_CODE';
						button.postback_action = '12345';
						break;
					case 'opt_in':
					case 'opt_out':
						button.type = 'QUICK_REPLY';
						break;
					default:
						button.type = 'QUICK_REPLY';
						break;
				}
			}
			
			// Sort buttons: non-QUICK_REPLY buttons first
			this.singleButton.sort((a, b) => {
				if (a.type !== 'QUICK_REPLY' && b.type === 'QUICK_REPLY') {
					return -1;
				} else if (a.type === 'QUICK_REPLY' && b.type !== 'QUICK_REPLY') {
					return 1;
				} else {
					return 0;
				}
			});

			this.openPopper = undefined;
			this.selectButtonType = false;
			this.buttonType = '';
			this.popperIndex = -1;
		},
		async saveTemplate() {  // Save message Templates
			if (!this.whatsAppSocialData) {
				useUIStore().updateToast({ open: true, message: "No WhatsApp account connected.", type: "danger" });
				return;
			}
			const singleButtonSnapshot = JSON.parse(JSON.stringify(this.singleButton || []));
			const carouselSnapshot = JSON.parse(JSON.stringify(this.carousel_message_json || {}));
			const restoreButtonConfigurations = () => {
				this.singleButton = JSON.parse(JSON.stringify(singleButtonSnapshot));
				this.carousel_message_json = JSON.parse(JSON.stringify(carouselSnapshot));
			};
			try {
				this.spinnerLoading = true;
				useUIStore().updateLoading({ isLoading: true, message: 'Saving template...' });
				let validName = this.validateTemplateName();
				
				// Validate expiration date when expiration is enabled
				if (this.dummyTemplate.template_subtype == 'LTO' && this.lto_offerExpirationRadio && (!this.expiration_date_time || this.expiration_date_time === null)) {
					return useUIStore().updateToast({ open: true, message: "Please select an expiration date and time for the offer!", type: "danger", duration: 4000 });
				}
				let headerType = this.body.header.format;
				if(this.body.body.text != '' && this.body.body.text != null){
					this.body.body.text = this.body.body.text.replace(/\n\n\n\n\n\n/g, '\n\n').replace(/\n\n\n\n\n/g, '\n\n').replace(/\n\n\n\n/g, '\n\n').replace(/\n\n\n/g, '\n\n');
        }
				if(!this.body.body.text) {
					return useUIStore().updateToast({ open: true, message: "Body text is required", type: "danger", duration: 4000 });
				}
				else if(!this.dummyTemplate.category || !this.dummyTemplate.language || !this.dummyTemplate.template_name) {
					return useUIStore().updateToast({ open: true, message: "Please enter all required details", type: "danger", duration: 4000 });
				}
				else if(!validName){
					return useUIStore().updateToast({ open: true, message: "Enter a valid template name. It must start with a lowercase letter and can only contain lowercase alphanumeric characters and underscores. No spaces.", type: "danger", duration: 4000 });
				} 
				else if(this.checkTemplateNameAlreadyExists()){ 
					return useUIStore().updateToast({ open: true, message: "Template name already exists.", type: "danger", duration: 4000 });
				}
				else if(this.body.body.text.indexOf('\n\n\n') > -1){
					return useUIStore().updateToast({ open: true, message: "You can't have more than 1 consecutive line breaks in the body!", type: "danger", duration: 4000 });
				} 
				else if (headerType !== '' && headerType !== null) {
					switch (headerType) {
						case 'TEXT':
							if (!this.body.header.text) return useUIStore().updateToast({ open: true, message: "Please enter the text in header!", type: "danger", duration: 4000 });
							break;
						case 'IMAGE':
						case 'VIDEO':
						case 'DOCUMENT':
						case 'FILE':
							if (!this.body.header.example || this.body.header.example.length == 0) return useUIStore().updateToast({ open: true, message: `Please add ${headerType.toLowerCase()} in header!`, type: "danger", duration: 4000 });
							break;
						default:
					}
				}
				this.loading = true;
				let reqBody = {
					category: this.dummyTemplate.category,
					language: this.dummyTemplate.language,
					template_name: this.dummyTemplate.template_name,
				}
				if(this.body.body.text) {
					this.body.body.text = this.body.body.text.replace(/\n{5,}/g, '\n\n');
				}
				this.body.body.params = this.cleanParams(); // removing params which doesn't have in body text
				const newArrayWithParams = this.body.body.params.map(item => item.param);
				this.body.body.example = [];
				await this.processNewArrayWithParams(newArrayWithParams); //adding example array for body 
				let counter = 1;
				var msgData = {
					"BODY": { "text": this.body.body.text.replace(/<[^>]+>/g, () => `{{${counter++}}}`) }
				};
				if(this.body.body.example.length > 0){
					msgData.BODY.example = this.body.body.example;
				}
				this.singleButtonbeforeModification = JSON.parse(JSON.stringify(this.singleButton));
				let invalid = false;
				for (let b of this.singleButton) {	
					if (b.type !== 'QUICK_REPLY' && (!b.action || !b.payload)) {
						useUIStore().updateToast({
							open: true,
							message: "Please select an action and enter the required value for all buttons.",
							type: "danger",
							duration: 4000
						});
						invalid = true;
						break;
					}

					if (b.action === 'website' && b.url_type === 'dynamic') {
						if (!b.payload.includes('{{1}}')) {
							// okay, will be handled later
						}
					}

					if ((b.action === 'phone' || b.action === 'phone_number') && !b.payload) {
						useUIStore().updateToast({
							open: true,
							message: "Please provide a valid phone number.",
							type: "danger",
							duration: 4000
						});
						invalid = true;
						break;
					}

					if (b.type !== 'QUICK_REPLY' && !['website', 'phone', 'phone_number', 'COPY_CODE'].includes(b.action)) {
						useUIStore().updateToast({
							open: true,
							message: "Please select a valid action for all buttons.",
							type: "danger",
							duration: 4000
						});
						invalid = true;
						break;
					}
				}
			if (invalid) return;

			// Step 2: Mutation pass
			this.singleButton.forEach(b => {
				if (b.action === 'website') {
					let final_url = b.payload;
					if(b.url_type === 'dynamic'){
						if(final_url.indexOf('{{1}}') == -1){
							final_url = final_url +"{{1}}";
						}
						b.example = ["1234567890"];
					}
					b.type = 'URL';
					b.url = final_url;
				} else if (b.action === 'phone' || b.action === 'phone_number') {
					b.type = 'PHONE_NUMBER';
					b.phone_number = b.payload;
				} else if (b.action === 'COPY_CODE') {
					b.type = 'COPY_CODE';
					b.payload = '12345';
				}

				if (b.action !== 'COPY_CODE' && b.type !== 'QUICK_REPLY') {
					delete b.payload;
				}

				delete b.url_type;
				delete b.action;
			});
				if(invalid) return;			
				if(this.singleButton.length > 0){
					msgData.BUTTONS = this.singleButton;
				}
				if(this.body.header.format && this.body.header.format !== 'None'){
					if(this.body.header.format == 'TEXT') {
						delete this.body.header.example;
					}
					msgData.HEADER = this.body.header;
				}
				if(this.body.footer.text){
					msgData.FOOTER = this.body.footer;
				}

				var messageParams = {
					BODY: newArrayWithParams
				};

				if(this.dummyTemplate.template_subtype == 'LTO'){  // For limited Offer template 
					const hasCopyCodeButton = msgData.BUTTONS.some(button => button.type === 'COPY_CODE');
					const hasUrlButton = msgData.BUTTONS.some(button => button.type === 'web_url' || button.type === 'URL');

					if (!hasCopyCodeButton) {
						restoreButtonConfigurations();
						return useUIStore().updateToast({ open: true, message: "Please add 'Copy code' button!", type: "danger", duration: 4000 });
					}
					if (!hasUrlButton) {
						restoreButtonConfigurations();
						return useUIStore().updateToast({ open: true, message: "Please add a URL type button (open a website)!", type: "danger", duration: 4000 });
					}

					// Set limited_time_offer data
					msgData.limited_time_offer = {
						text: this.lto_offerTitleText,
						has_expiration: this.lto_offerExpirationRadio,
					};

					// Prepare limited_time_offer message params (if applicable)
					var lto_message_params = null;

					if(this.lto_offerExpirationRadio){
							const expirationTime = this.expiration_date_time;
							const [hours, minutes] = expirationTime.split(':');
							if (hours && minutes && minutes.length === 2) {
								const formattedExpirationTime = `${expirationTime}`;
								lto_message_params = {
									limited_time_offer: {
										expiration_time: formattedExpirationTime,
									},
								};
								messageParams['limited_time_offer'] = lto_message_params.limited_time_offer
							}
					}
					reqBody.message = msgData;
					reqBody.message_type = (this.dummyTemplate.template_subtype || 'lto').toLowerCase();
        } else if(this.dummyTemplate.template_subtype == 'Carousel'){ // For Carousel template
					this.$refs.CarouselComponent?.processCarouselData();
					var msgData_carousel = this.carousel_message_json;
					// Remove unnecessary buttons array if it exists
					if (msgData_carousel?.CAROUSEL?.buttons) {
						delete msgData_carousel.CAROUSEL.buttons;
					}
					const cards = msgData_carousel.CAROUSEL.cards;
					for (let i = 0; i < cards.length; i++) {
						this.removeFilesUploadingBoolean(cards[i].components);
					}
					msgData_carousel.BODY = msgData.BODY;
					if(this.validateCarouselData(msgData_carousel)){
						for (const card of msgData_carousel.CAROUSEL.cards) {
							for (const button of card.components[2].buttons) {
								// Update button properties
								button.text = button.title || button.text;
								delete button.title;
								button.type = button.type === 'web_url' ||  button.type === 'website' ? "URL" : button.type; // Convert button types
								if (button.type === 'URL') {
									let final_url = button.payload;
									// Handle dynamic URLs
									if (button.url_type === 'dynamic') {
										if (final_url.indexOf('{{1}}') == -1) {
											final_url = final_url + "{{1}}";
										}
										button.example = ["1234567890"];
									}
									button.url = final_url;
									delete button.payload;
								}
								delete button.url_type;
							}
						}
						reqBody.message = msgData_carousel;
						reqBody.message_type = (this.dummyTemplate.template_subtype || 'carousel').toLowerCase();
					} else {
						console.info('carousel Validation error')
						restoreButtonConfigurations();
						return
					}
				} else if(this.dummyTemplate.template_subtype == 'Coupon'){ // For Coupon Template
					const hasCopyCodeButton = msgData.BUTTONS.some(button => button.type === 'COPY_CODE');
					if (!hasCopyCodeButton) {
						restoreButtonConfigurations();
						return useUIStore().updateToast({ open: true, message: "Please add 'Copy code' button!", type: "danger", duration: 4000 });
					}
          reqBody.message = msgData;
          reqBody.message_type = (this.dummyTemplate.template_subtype || 'coupon').toLowerCase();
        }
				else {
					reqBody.message = msgData;
					reqBody.message_type = (this.dummyTemplate.template_subtype || 'generic').toLowerCase();
				}
				reqBody.message_params = messageParams;
				reqBody.channel = "whatsapp";
				if(this.$route.params.id){
					reqBody['id'] = this.thisTemplate.template_id;
        }
				if(typeof this.dummyTemplate.template_subtype != 'undefined' && this.dummyTemplate.template_subtype != '' && this.dummyTemplate.template_subtype != 'generic'){
					reqBody['template_subtype'] = this.dummyTemplate.template_subtype;
				}
				if(jsonSizeInKB(reqBody?.message) > 16) {
					restoreButtonConfigurations();
          return useUIStore().updateToast({ open: true, message: 'The information you are sending (called a "payload") exceeds the API limit of 16 KB.Please reduce the size of your message, attachments, or interactive elements, and try again.', type: "danger", duration: 7000 });
        }
				if(this.$route.params.id) {
					await apiInterceptor.put(environment("VUE_APP_API_URL") + "social/v1/whatsapp/" + this.whatsAppSocialData.id + '/template/' + this.$route.params.id, reqBody );
				} else {
					await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/whatsapp/" + this.whatsAppSocialData.id + '/template', reqBody );
				}
				useUIStore().updateToast({
					open: true,
					message: "Template added successfully!",
					type: "success"
				});
				queryClient.invalidateQueries({ queryKey: ['whatsapp-templates'] });
				this.custom_field_body_params = [];
				this.custom_field_values = [];
				this.body.body.params = [];
				this.$router.push({ path: '/sales-channel/whatsapp/message-templates' });
			} catch (error) {
				restoreButtonConfigurations();
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger",
					duration: 5000
        })
			} finally {
				this.loading = false;
				this.spinnerLoading = false;
				useUIStore().updateLoading({ isLoading: false });
			}
		},
		cleanParams() {
			const text = this.body.body.text;
			const params = this.body.body.params;

			const variableRegex = /<[^>]+>/g;
			const variablesInText = text.match(variableRegex) || [];

			const cleanedParams = [];

			for (const variable of variablesInText) {
				const matchingParam = params.find(p => Object.keys(p.param)[0] === variable);
				if (matchingParam) {
					cleanedParams.push(matchingParam);
				}
			}

			return cleanedParams;
		},
		async processNewArrayWithParams(newArrayWithParams) { //adding example array for body 
			if (!newArrayWithParams || !Array.isArray(newArrayWithParams) || newArrayWithParams.length === 0) {
				return;
			}
			const newArray = newArrayWithParams.map(item => {
				if (typeof item === 'object') {
					return Object.keys(item);
				} else {
					return item;
				}
			});

			const replacements = {
				'<userfirstname>': 'John',
				'<userlastname>': 'Snow',
				'<useremail>': 'support@mybrandstore.com',
				'<userphone>': '+6590000000',
			};
			const examples = [];
			for (const element of newArray) {
				const processedExampleObj = {};
				processedExampleObj[element] = replacements[element] || (element.indexOf('<custom_field_') ? this.findCustomFieldValue(element[0]) : element); // Use element as key
				examples.push(processedExampleObj);
			}

			const extractValues = examples.map(obj => Object.values(obj)[0])
			this.body.body.example = examples.length === 1 ? [extractValues[0]] : [extractValues];
		},
		findCustomFieldValue(key) {
			return this.custom_field_body_params?.find(param => param.key === key)?.value || 'Custom field';
		},
		validateRequiredProperty(button, property) {
			if (!button[property] || !button[property].length) {
				return useUIStore().updateToast({
					open: true,
					message: `Please provide a valid ${property}`,
					type: "danger",
					duration: 4000
				});
				
			}
		},
		validateTemplateName(){
			var regex = /^[a-z_][a-z\d_]*$/;
			var valid = !!this.dummyTemplate.template_name && regex.test(this.dummyTemplate.template_name);
			return valid;
    },
		getNewTemplateName(){
			var template_name = "template_" + Math.floor((Math.random() * 1000) + 1);
			if(this.checkTemplateNameAlreadyExists(template_name)){
				return this.getNewTemplateName();
			}
			else{
				return template_name;
			}
    },
		checkTemplateNameAlreadyExists(name){
			var tName = name || this.dummyTemplate.template_name;
			var exist = (this.allTemplates.filter((item) => {
					return item.template_name == tName;
			}).length > 0);
			return exist;
    },
		removeButton() {
			try {
				if(this.popperIndex > -1) {
					this.singleButton.splice(this.popperIndex, 1);
				}
			} catch (error) {
				console.error("Exception", error);
			} finally {
				this.selectButtonType = false;
				this.buttonType = '';
				this.openPopper = undefined;
				this.popperIndex = -1;
			}
		},
		async onTemplateSelection() {
			await this.resetTemplateData();
      switch (this.dummyTemplate.template_subtype) {
        case 'LTO':
					this.singleButton = [{
						"text": "Copy code",
						"action": "COPY_CODE",
						"payload": "12345",
					},
					{
						"text": "URL Button",
						"action": "website",
						"payload": "",
					}];
          break;
				case 'generic':
					this.singleButton = [];
					break;
				case 'Carousel':
					setTimeout(() => {
						this.$refs.CarouselComponent?.addNewCarouselCard('0');
					}, 100);
					this.singleButton = [];
					break;
				case 'Coupon':
					this.singleButton = [{
						"text": "Copy code",
						"action": "COPY_CODE",
						"payload": "12345",
					}];
					break;
        default:
					this.singleButton = [];
					return;
      }
    },
		updatedValues(value){
			this.body.header.text = value;
		},
		selectedBodyFormat(format){
			this.body.header.format = format;
		},
		async onButtonTypeSelection() {
			this.openPopper = undefined; // reset popper
			await this.$nextTick();
			switch (this.buttonType) {
				case 'phone':
					this.configurePopper('simple', 'phone');
					this.showAgents = false;
					break;
				case 'url':
					this.showAgents = false;
					this.configurePopper('simple', 'website');
					break;
				case 'quickReply':
					this.openPopper = 'detailed';
					this.showAgents = true;
					this.popperConfig.action = undefined;
					break;
				default:
					return '';
			}
		},
		configurePopper(openPopperType, actionType) {
			this.openPopper = openPopperType;
			delete this.popperConfig.type;
			this.popperConfig.action = actionType;
		},
		handleReorder() {
			// VueDraggable handles reorder via v-model automatically
		},
		parseButtonInfo(buttonInfo, index){
			if (buttonInfo.type === 'PHONE_NUMBER') {
				buttonInfo.action = 'phone';
				buttonInfo.payload = buttonInfo.phone_number;
			}
			if(buttonInfo.type === 'URL'){
				buttonInfo.action = 'website';
				buttonInfo.payload = buttonInfo.url;
			}
			if(this.shouldShowPopper){
				return useUIStore().updateToast({ open: true, message: "Please save your changes to the current button before editing a new one.", type: "warning" })
			}
			if(buttonInfo.type == undefined && buttonInfo.action == undefined) { 
				this.selectButtonType = true; // selecting Button Type
			}
			else if(this.dummyTemplate.template_subtype == 'LTO' || (buttonInfo.type !== 'QUICK_REPLY' && buttonInfo.action !== 'QUICK_REPLY' )){
				this.openPopper = 'simple'; // CTA buttons Popper
			}
			else if(buttonInfo.type == 'QUICK_REPLY') {
				this.showAgents = true;
				this.openPopper = 'detailed'; // QuickReply buttons Popper
			}
			this.popperIndex = index;
			this.popperConfig = this.singleButton[index];
		},
		modifyParams(value){
			const modifiedParams = `<${value}>`;
			this.addParam(modifiedParams, false);
		},
		removeParams(value) {
			// Clean up the input value by removing any <>/{} formatting
			const cleanValue = value.replace(/[<>{}]/g, '').toLowerCase();
			this.body.body.params = this.body.body.params.filter(p => {
				const paramKey = Object.keys(p.param)[0].replace(/[<>]/g, '').toLowerCase();
				// Check if param matches based on the key or text value
				const textLower = p.text.toLowerCase();
				if (cleanValue.startsWith('custom_field_')) {
					return !paramKey.includes(cleanValue); // for custom fields removal
				} else {
					// Check both the key and the display text for a match
					return paramKey !== cleanValue && !textLower.includes(cleanValue);
				}
			});
			// Removal of custom fields sample array
			this.custom_field_body_params = this.custom_field_body_params.filter(p => {
				const paramKey = p.key.replace(/[<>]/g, '').toLowerCase();
				return paramKey !== cleanValue;
			});
		},
		addParam(param, modifyText, pIndex) {
			const paramDetails = this.exampleParamOptions.find(option => option.param.startsWith(param));
			const textToInsert = paramDetails?.text || param;
			const paramObject = { [param]: "text" };
			const isCustomField = param.startsWith('<custom_field_');
			const customFieldText = param.replace("<custom_field_", "").replace(">", "");
			if (modifyText) {
				this.body.body.text = this.body.body.text.replace(
					`{{${pIndex}}}`,
					isCustomField ? `{custom_field_${customFieldText}}` : `{${textToInsert}}`
				);
			}
			this.body.body.params.push({
				text: isCustomField ? `{custom_field_${customFieldText}}` : textToInsert,
				param: isCustomField ? { [`<custom_field_${customFieldText}>`]: 'text' } : paramObject,
				example: paramDetails?.example || '',
			});
			if(isCustomField){
				const customFieldParamsWithNewKey = this.body.body.params.filter(item => item.text.includes("{custom_field_"));
				this.custom_field_body_params = customFieldParamsWithNewKey.map(item => ({
					...item,
					value: "",
					key: `<${item.text.replace(/{|}/g, '')}>`
				}));
			}
		},
		validateCarouselData(msgDataCarousel) {
			// Check for missing buttons
			if (!msgDataCarousel.CAROUSEL.cards.every(card => card.components[2].buttons.length > 0)) {
				useUIStore().updateToast({ open: true, message: "Please add at least one button for each card.", type: "danger", duration: 4000 });
				return false
			}

			// Check for inconsistent button count
			const buttonCounts = msgDataCarousel.CAROUSEL.cards.map(card => card.components[2].buttons.length);
			if (buttonCounts.some(count => count !== buttonCounts[0])) {
				useUIStore().updateToast({ open: true, message: "Please ensure all cards have the same number of buttons.", type: "danger", duration: 4000 });
				return false
			}

			// Check for missing button properties (URL or payload)
			for (const card of msgDataCarousel.CAROUSEL.cards) {
				for (const button of card.components[2].buttons) {
					if (!button.url && !button.payload) {
						useUIStore().updateToast({ open: true, message: "Please add button action (URL or payload) for all buttons.", type: "danger", duration: 4000 });	
						return false
					}
				}
			}

			// Check for inconsistent header type
			const headerFormats = msgDataCarousel.CAROUSEL.cards.map(card => card.components[0].format);
			if (headerFormats.some(format => format !== headerFormats[0])) {
				useUIStore().updateToast({ open: true, message: "Please make sure that All cards have same type of media header (either all image or all video)!", type: "danger", duration: 4000 });	
				return false
			}

			// validate image/video for cards
			const invalidCards = msgDataCarousel.CAROUSEL.cards.filter(card => {
					const component = card.components[0];
					return (!component.format || component.format === '' || !component.image_url || component.image_url === '');
			});

			if (invalidCards.length > 0) {
					useUIStore().updateToast({ open: true, message: "Please make sure that all the cards have media header (image or video)!", type: "danger", duration: 4000 });	
					return false;
			}
			// Check that each card has a BODY component with non-empty text
			if (!msgDataCarousel.CAROUSEL.cards.every(card =>
				card.components.some(component =>
					component.type === "BODY" && component.text && component.text.trim() !== ""
				)
			)) {
				useUIStore().updateToast({ open: true, message: "Please ensure all carousels have body text", type: "danger", duration: 4000 });
				return false;
			}
			// Check for inconsistent button types across all cards
			const referenceCard = msgDataCarousel.CAROUSEL.cards[0];
			for (const card of msgDataCarousel.CAROUSEL.cards) {
				if (!this.checkButtonConsistency(card, referenceCard)) {
					useUIStore().updateToast({ open: true, message: "Please make sure that all cards have same amount of buttons and in same order!", type: "danger", duration: 4000 });
					return false;
				}
			}
			return true;
		},
		checkButtonConsistency(card, referenceCard) {
			// Check if button types and order are consistent
			return card.components[2].buttons.every((button, index) => button.type === referenceCard.components[2].buttons[index].type);
		},
		finalCarouselData(carouselData) {
			this.carousel_message_json = carouselData;
		},
		resetTemplateData(type) {
			this.body = {
					header: {
						format: undefined,
						text: undefined,
						example: ''
					},
					body: {
						text: undefined,
						params: [],
						example: []
					},
					footer: {
						text: undefined,
					}
			};
			if(type == 'all'){
				this.dummyTemplate = {
					category: 'MARKETING',
					id: undefined,
					language: 'en',
					status: undefined,
					template_id: undefined,
					template_name: undefined,
					template_subtype: 'generic',
				};	
			}
			this.popperConfig = {
				text: undefined,
				action: undefined,
				payload: undefined
			},
			this.allExampleValues = [];
			this.custom_field_values = [];
			this.lto_offerTitleText = '';
      this.lto_offerExpirationRadio = true;
			this.expiration_date_time = null;
			this.buttonType = '';
			this.custom_field_body_params = [];
			this.selectButtonType = false
			this.openPopper = undefined;
			this.singleButtonbeforeModification = [];
			this.carousel_message_json = {
				BODY: {
						text: ""
				},
				CAROUSEL: {
						cards: []
				}
			};
    },
		getIcon(thisButton) {
			if (thisButton.action === 'phone' || thisButton.action === 'phone_number' || thisButton.type === 'PHONE_NUMBER') {
				return this.callOutline;
			} else if (thisButton.action === 'website' || thisButton.type === 'URL') {
				return this.shareOutline;
			} else if (thisButton.action === 'COPY_CODE' || thisButton.type === 'COPY_CODE') {
				return this.copyOutline;
			}  else if(thisButton.payload == 'compliance_opt_in') {
        return marketingOptinSubscribed;
      } else if(thisButton.payload == 'compliance_opt_out') {
        return marketingOptinUnsubscribed;
      } else if (thisButton.type === 'QUICK_REPLY') {
				return this.arrowUndoOutline;
			} else {
				return '';
			}
		},
		setMessageTags(){
      this.simpleMessageTags = messageTags?.allChannelsMessageTags?.filter(({tag}) => ['userfirstname', 'userlastname', 'useremail', 'userphone'].includes(tag));
    },
		removeFilesUploadingBoolean(components) {
      for (let i = 0; i < components.length; i++) {
        delete components[i].filesUploading;
      }
    },
		learnMore() {
      window.open('https://developers.facebook.com/docs/whatsapp/business-management-api/message-templates', '_blank');
    },
  }
}
</script>

<style scoped>
::v-deep(.select-drop-down-wrapper .icon-inner) {
  color: var(--gray-04);
}
::v-deep(.select-drop-down-wrapper .main-selector) {
  height: 48px;
}
/* Toolbar header */
.toolbar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 20px;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}
.save-btn {
  margin-left: auto;
}
/* Mobile tabs */
.mobile-tabs {
  display: none;
  background: var(--white);
  padding: 10px 20px;
  gap: 10px;
  border-bottom: 1px solid var(--background-primary);
}
.tab-item {
  background: none;
  border: none;
  font: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-04);
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.tab-item.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
  font-weight: 500;
}
/* Form inputs */
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.prevMobile {
  display: none;
}
.prevDesktop {
  display: block;
}
.templateAddButton {
  color: var(--purple);
  background: var(--white);
  border: 1px solid var(--purple);
  border-radius: 0px 0px 5px 5px;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  margin: 0;
  margin-top: -3px;
  transition: background 0.2s;
}
.templateAddButton:hover {
  background: var(--purple-opac);
}
.templateAddButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.previewHeader, .templateHeader{
  border-bottom: 1px solid var(--background-primary);
  color: var(--black);
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  padding: 20px;
}
.templateHeader{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.model-sections {
  background: var(--white);
  border-radius: 5px;
}
.custPaddingRight{
  padding-right: 20px;
}
.custPaddingtop {
	padding-top: 20px;
}
.domainContainer{
  padding-bottom: 10px;
  margin-bottom: 10px;
	width: 100%;
}
.expiryButton {
  padding: 10px 0;
}
.popperContainer{
	margin-top: 10px;
	border: 1px solid var(--background-primary);
	padding: 20px;
}
.marginTop {
	margin-top: 20px;
}
.custMarginTop{
	margin-top: 5px;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  background: var(--purple-opac);
  padding: 15px 10px;
  border-radius: 5px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin-left: 8px;
}
.chatgpt-container{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 5px;
}
.flex-container{
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 5px;
}
.status {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: inline-block !important;
  margin-right: 10px;
}
.flex-box{
	display: flex;
	align-items: center;
	gap: 5px;
}
.templateInput{
	border: 1px solid var(--black);
	border-radius: 5px 5px 0px 0px;
	border-bottom: none;
	padding: 0px 0px 30px 0px;
}
.carousel_templateInput{
	border: 1px solid var(--black);
	border-radius: 5px;
}
.flexContainer, .BodyFlexContainer{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bodyContainer{
	width: 60%;
}
.date-time-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.date-time-wrapper .left {
  display: flex;
  flex: 1;
  column-gap: 10px;
}
.date-time-wrapper .right {
  width: 25px;
}
.bttnContainer{
	background: var(--white);
	border: 1px solid var(--purple);
	height: 50px;
	display: flex;
	align-items: center;
}
.bttnContainer:last-child{
	border-radius: 0px 0px 5px 5px;
	padding-bottom: 7px;
	height: 57px;
}
.bttnContainer:not(:last-child) {
  border-bottom: none;
}
.bttnContainer:hover{
	background: var(--purple-opac);
}
.bttnContainer:hover .bttnTitle{
	color: var(--purple);
}
.bttnContainer:hover .vicon{
	color: var(--purple);
}
.activeButton{
	background: var(--purple-opac);
}
.activeButton .bttnTitle{
	color: var(--purple);
}
.activeButton .reorder-container{
	background: var(--purple-opac);
}
.activeButton .reorder-icon{
	color: var(--purple);
}
.bttnTitle{
	color: var(--purple);
	font-size: 14px;
	font-weight: 400;
}
.reorder-container{
  width: 60px;
  height: 48px;
  background: var(--purple-opac);
	border-right: 1px solid var(--purple);
	cursor: pointer;
}
.bttnContainer:last-child .reorder-container {
	border-radius: 0px 0px 0px 5px;
}
.button-text-container {
  display: flex;
  justify-content: center;
  align-items: center;
	gap: 5px;
}
.buttonMargin{
	flex-grow: 1;
	padding-right: 60px;
}
.reorder-icon{
	width: 25px;
	height: 25px;
}
.optionsContainer{
	display: flex;
  justify-content: space-between;
	flex-direction: row;
	gap: 20px;
}
.optionsContainer div {
	flex-grow: 1;
}
.lastButton, .ltoButton{
	padding-bottom: 0px !important;
	height: 50px !important;
}
.footerTop{
	margin-top: 15px;
}
.messageHeader{
	font-size: 18px;
	color: var(--black);
	font-weight: 400;
	line-height: 16px;
}
.activeIcon{
	color: var(--purple);
}
.jinput.textarea {
  max-height: 100%;
}
.justifyBetween{
	justify-content: space-between;
}
@media only screen and (max-width: 760px) {
  .mobile-tabs {
    display: flex;
  }
  .prevMobile {
		display: block;
	}
  .prevDesktop {
    display: none;
  }
	.container{
  	margin: 15px;
	}
	.bodyContainer{
		width: 100%;
	}
	.custPaddingRight{
		padding-right: 0px;
	}
	.buttonMargin{
		margin: 0px 28%;
	}
	.BodyFlexContainer{
		flex-direction: column;
		align-items: normal;
	}
	.mobileMargin{
		margin-bottom: 20px;
	}
	.optionsContainer{
		justify-content: space-between;
		flex-direction: column;
		gap: 0px;
	}
}
</style>